export const theme = {
  primary: "#FB693C",
  pink: "#ffe1de",
  green: "#ACB9A2",
  gray: "#909090",
  white: "#FFFFFF",
};

export const darkTheme = {
  primary: "#FB693C", // Orange (kept consistent for branding)
  pink: "#4A2E2C", // Dark Pink (contrast for dark background)
  green: "#384737", // Dark Green
  gray: "#2E2E2E", // Dark Gray
  white: "#1E1E1E", // Off-Black for backgrounds
  text: "#EDEDED", // Light Gray for text on dark backgrounds
};